module.exports = __webpack_public_path__ + "static/media/audit_assistance.5721d37b.svg";